// // src/firebase/config.js
// // Vite or CRA のどちらでも動く安全な環境変数ロード
// const viteEnv = (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env : {};
// const env = {
//   ...process.env,
//   ...viteEnv,
// };

// const pick = (...keys) => keys.map(k => env[k]).find(Boolean) || '';

// const firebaseConfig = {
//   apiKey: pick('VITE_FIREBASE_API_KEY', 'REACT_APP_FIREBASE_API_KEY'),
//   authDomain: pick('VITE_FIREBASE_AUTH_DOMAIN', 'REACT_APP_FIREBASE_AUTH_DOMAIN'),
//   projectId: pick('VITE_FIREBASE_PROJECT_ID', 'REACT_APP_FIREBASE_PROJECT_ID'),
//   storageBucket: pick('VITE_FIREBASE_STORAGE_BUCKET', 'REACT_APP_FIREBASE_STORAGE_BUCKET'),
//   messagingSenderId: pick('VITE_FIREBASE_MESSAGING_SENDER_ID', 'REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
//   appId: pick('VITE_FIREBASE_APP_ID', 'REACT_APP_FIREBASE_APP_ID'),
// };

// // 足りない値があれば起動時に気づけるよう警告（必要なら throw に）
// for (const [k, v] of Object.entries(firebaseConfig)) {
//   if (!v) console.warn(`[firebase-config] Missing env for ${k}`);
// }

// export default firebaseConfig;


// src/firebase/config.js
const viteEnv = (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env : {};
const env = { ...process.env, ...viteEnv };
const pick = (...keys) => keys.map(k => env[k]).find(Boolean) || '';

const firebaseConfig = {
  apiKey: pick('VITE_FIREBASE_API_KEY', 'REACT_APP_FIREBASE_API_KEY'),
  authDomain: pick('VITE_FIREBASE_AUTH_DOMAIN', 'REACT_APP_FIREBASE_AUTH_DOMAIN'),
  projectId: pick('VITE_FIREBASE_PROJECT_ID', 'REACT_APP_FIREBASE_PROJECT_ID'),
  storageBucket: pick('VITE_FIREBASE_STORAGE_BUCKET', 'REACT_APP_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: pick('VITE_FIREBASE_MESSAGING_SENDER_ID', 'REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: pick('VITE_FIREBASE_APP_ID', 'REACT_APP_FIREBASE_APP_ID'),
};

// ✅ 必須3つを厳格チェック（PWAで必須）
for (const k of ['apiKey', 'projectId', 'appId']) {
  if (!firebaseConfig[k]) {
    throw new Error(`[firebase-config] Missing "${k}". Check your .env(.production) in /pwa and prefix (VITE_ or REACT_APP_).`);
  }
}

export default firebaseConfig;
